import {bgLayer, EXTENT, LAYERS, overlay, templateLayer} from '../config/layers.config';
import * as ol from 'openlayers';
import {environment} from '../../environments/environment';

export const LayerActions = {
  INIT: 'INIT',
  SET_EXTENT: 'SET_EXTENT',
  INIT_DONE: 'INIT_DONE',
  ADD_LAYER: 'ADD_LAYER',
  TOGGLE_LAYER: 'TOGGLE_LAYER',
  TOGGLE_STREET_OVERLAY: 'TOGGLE_STREET_OVERLAY',
  SET_CALENDAR_DATE: 'SET_CALENDAR_DATE',
  SET_COMPARE_DATE: 'SET_COMPARE_DATE',
  CANCEL_REQUESTS: 'CANCEL_REQUESTS',
  SET_YEAR: 'SET_YEAR'
};

export interface LayerState {
  map: ol.Map;
  boundingExtent: number[];
  extent: number[];
  projection: string;
  bgLayer: any;
  streetOverlay: any;
  compareLayer: any;
  compareDate: Date;
  layers: any[];
  calendarDate: any;
  init: boolean;
  selectedYear: string;
}

export const L_INIT_STATE: LayerState = {
  map: null,
  boundingExtent: EXTENT,
  extent: EXTENT,
  projection: 'EPSG:3857',
  bgLayer: bgLayer,
  streetOverlay: overlay,
  compareLayer: null,
  compareDate: undefined,
  layers: LAYERS,
  calendarDate: null,
  init: true,
  selectedYear: ''
};

export function layerReducer(state = L_INIT_STATE, action) {
  switch (action.type) {

    case LayerActions.INIT:
      const years = state.layers.map(l => l.year).sort();
      state = layerReducer(state, {type: LayerActions.SET_YEAR, body: {year: years[years.length - 1]}});
      break;

    case LayerActions.TOGGLE_STREET_OVERLAY:
      const streetOverlay = state.streetOverlay;
      streetOverlay.visible = !streetOverlay.visible;
      state = Object.assign({}, state);

      break;

    case LayerActions.SET_YEAR:
      const year = action.body.year;
      const layers = state.layers.map(l => {
        l.visible =  l.year === year;
        return l;
      });
      state = Object.assign({}, state, {
        layers: layers,
        selectedYear: year
      });

      break;
  }
  return state;
}






// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Angular_wig_cropmap_master/src/app/reducers/layer.reducer.ts